// import {
//    Box,
//    Button,
//    Flex,
//    HStack,
//    Text,
//    VStack,
//    Checkbox,
//    Spinner,
//    Card,
//    CardHeader,
//    CardBody,
//    Badge,
//    IconButton,
//    useColorModeValue,
//    Divider,
//    SimpleGrid,
// } from '@chakra-ui/react';
// import { useGlobal } from 'contexts';
// import React, { useState, useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { IoMdArrowRoundBack, IoMdSave, IoMdRefresh, IoMdCheckmarkCircleOutline } from 'react-icons/io';
// import { Link } from 'react-router-dom';
// import { renderSwitchControl } from 'utils/DynamicFormData';
// import { updateUserGlobalSettings, userGlobalSettings } from '../../../../redux/actions/settings';

// export default function GlobalSetting() {
//    const { userGlobalSettingsData } = useGlobal();
//    const dispatch = useDispatch();
//    const [isUpdating, setIsUpdating] = useState(false);
//    const [formData, setFormData] = useState({});
//    const [companyWiseWp, setCompanyWiseWp] = useState();

//    // Color mode values for modern theme
//    const cardBg = useColorModeValue('white', 'gray.800');
//    const borderColor = useColorModeValue('gray.200', 'gray.600');
//    const accentColor = useColorModeValue('blue.500', 'blue.400');

//    const globalSettings = userGlobalSettingsData?.[0]; // Get first object from array

//    // Initialize form data with existing values
//    useEffect(() => {
//       if (globalSettings?.askCompany) {
//          setFormData(globalSettings.askCompany);
//          setCompanyWiseWp(globalSettings.companyWiseWp);
//       }
//    }, [globalSettings]);

//    // Handle form submission
//    const handleSubmit = async () => {
//       setIsUpdating(true);

//       try {
//          // Prepare complete payload as per your API requirements
//          const payload = {
//             id: globalSettings.id,
//             status: globalSettings.status,
//             deviceId: globalSettings.deviceId,
//             instanceId: globalSettings.instanceId,
//             accessToken: globalSettings.accessToken,
//             companyWiseWp: companyWiseWp,
//             askCompany: formData,
//          };

//          // Dispatch the Redux action
//          await dispatch(updateUserGlobalSettings(payload));

//          // Re-fetch the updated data
//          await dispatch(userGlobalSettings());
//       } catch (error) {
//          console.error('Error updating settings:', error);
//       } finally {
//          setIsUpdating(false);
//       }
//    };

//    // Handle checkbox change (only updates local state, not API)
//    const handleCheckboxChange = (fieldName, isChecked) => {
//       if (fieldName === 'companyWiseWp') {
//          setCompanyWiseWp(isChecked);
//       } else {
//          setFormData((prev) => ({
//             ...prev,
//             [fieldName]: isChecked,
//          }));
//       }
//    };

//    // Define all fields from the original categories in simple array format
//    const settingsFields = [
//       { key: 'account', label: 'Account' },
//       { key: 'bllTerm', label: 'Bill Term' },
//       { key: 'daybook', label: 'Daybook' },
//       { key: 'bankBranch', label: 'Bank Branch' },
//       { key: 'item', label: 'Item' },
//       { key: 'category', label: 'Category' },
//       { key: 'itemGroup', label: 'Item Group' },
//       { key: 'brand', label: 'Brand' },
//       { key: 'size', label: 'Size' },
//       { key: 'color', label: 'Color' },
//       { key: 'style', label: 'Style' },
//       { key: 'series', label: 'Series' },
//       { key: 'warehouse', label: 'Warehouse' },
//       { key: 'transport', label: 'Transport' },
//       { key: 'driver', label: 'Driver' },
//       { key: 'vehicle', label: 'Vehicle' },
//       { key: 'companyWiseWp', label: 'Company Wise Wp' },
//    ];

//    // Check if form has changes
//    const hasChanges =
//       JSON.stringify(formData) !== JSON.stringify(globalSettings?.askCompany || {}) ||
//       companyWiseWp !== globalSettings.companyWiseWp;

//    // Count enabled settings
//    const enabledCount = settingsFields.filter((field) => formData[field.key]).length;
//    const totalCount = settingsFields.length;

//    return (
//       <Box minH="100vh" pb={8}>
//          {/* Header Section */}
//          <Flex mt="30px" justifyItems={'center'} gap={4}>
//             <Link to="/admin/setting">
//                <Button mb="15px">
//                   <IoMdArrowRoundBack size={18} />
//                </Button>
//             </Link>

//             <HStack mb={6} justify="space-between">
//                <Text fontSize="2xl" fontWeight="bold">
//                   Company Wise Master Settings
//                </Text>
//             </HStack>
//          </Flex>

//          {/* Main Content Card */}
//          <Card shadow="lg" border="1px" borderColor={borderColor} bg={cardBg} minH="80vh">
//             <CardHeader pb={4}>
//                <HStack justify="space-between" align="center">
//                   <Box>
//                      {/* <Text fontSize="xl" fontWeight="semibold">
//                         Company Wise Master Setting
//                      </Text>
//                      <Text fontSize="sm" color="gray.600" mt={1}>
//                         Configure which fields should be asked when creating company records
//                      </Text> */}
//                   </Box>

//                   {/* Action Buttons */}
//                   <HStack spacing={3}>
//                      <Badge px={3} py={1} fontSize="sm" colorScheme={enabledCount === totalCount ? 'green' : 'blue'}>
//                         {enabledCount}/{totalCount} enabled
//                      </Badge>
//                      <Button
//                         variant="outline"
//                         leftIcon={<IoMdRefresh />}
//                         onClick={() => setFormData(globalSettings?.askCompany || {})}
//                         isDisabled={!hasChanges || isUpdating}
//                         size="sm">
//                         Reset
//                      </Button>

//                      <Button
//                         colorScheme="blue"
//                         leftIcon={isUpdating ? <Spinner size="sm" /> : <IoMdSave />}
//                         isLoading={isUpdating}
//                         loadingText="Saving..."
//                         onClick={handleSubmit}
//                         isDisabled={!hasChanges}
//                         size="sm"
//                         shadow="md">
//                         Save Settings
//                      </Button>
//                   </HStack>
//                </HStack>
//             </CardHeader>

//             <CardBody pt={0} maxH="calc(80vh - 180px)" overflowY="auto">
//                {/* Changes Indicator */}
//                {hasChanges && (
//                   <Box
//                      mb={6}
//                      p={4}
//                      bg="blue.50"
//                      borderRadius="lg"
//                      border="1px solid"
//                      borderColor="blue.200"
//                      position="relative"
//                      overflow="hidden">
//                      <Box position="absolute" top={0} left={0} height="full" width="4px" bg="blue.400" />
//                      <HStack>
//                         <IoMdCheckmarkCircleOutline color="blue.500" size={20} />
//                         <Text fontSize="sm" color="blue.700" fontWeight="medium">
//                            You have unsaved changes. Click "Save Settings" to apply them.
//                         </Text>
//                      </HStack>
//                   </Box>
//                )}

//                {/* Two Column Settings Grid */}
//                <SimpleGrid columns={2} spacing={6} maxW="800px">
//                   {settingsFields.map((field) => (
//                      <Box
//                         key={field.key}
//                         p={6}
//                         borderRadius="lg"
//                         border="2px solid"
//                         borderColor={formData[field.key] ? 'blue.300' : 'gray.200'}
//                         bg={formData[field.key] ? 'blue.50' : 'white'}
//                         transition="all 0.3s ease"
//                         _hover={{
//                            shadow: 'lg',
//                            borderColor: 'blue.400',
//                            cursor: 'pointer',
//                            transform: 'translateY(-2px)',
//                         }}
//                         onClick={() =>
//                            !isUpdating &&
//                            handleCheckboxChange(
//                               field.key,
//                               field.key === 'companyWiseWp' ? !companyWiseWp : !formData[field.key],
//                            )
//                         }
//                         position="relative">
//                         {/* Status Indicator */}
//                         <Box
//                            position="absolute"
//                            top={3}
//                            right={3}
//                            w={3}
//                            h={3}
//                            borderRadius="full"
//                            bg={
//                               field.key === 'companyWiseWp'
//                                  ? companyWiseWp
//                                     ? 'green.400'
//                                     : 'gray.300'
//                                  : formData[field.key]
//                                  ? 'green.400'
//                                  : 'gray.300'
//                            }
//                            transition="all 0.2s"
//                         />

//                         <VStack align="start" spacing={3}>
//                            <Checkbox
//                               isChecked={
//                                  field.key === 'companyWiseWp' ? companyWiseWp || false : formData[field.key] || false
//                               }
//                               onChange={(e) => e.stopPropagation()}
//                               isDisabled={isUpdating}
//                               colorScheme="blue"
//                               size="lg"
//                               pointerEvents="none">
//                               <Text fontWeight="bold" fontSize="lg" color="gray.700">
//                                  {field.label}
//                               </Text>
//                            </Checkbox>
//                         </VStack>
//                      </Box>
//                   ))}
//                </SimpleGrid>
//                {/* <GridItem className="seperator-width">
//                   {renderSwitchControl(
//                      'companyWiseWp',
//                      'Company wiseWp',
//                      {
//                         isChecked: companyWiseWp,
//                         onChange: handleSwitchChange('companyWiseWp'),
//                      },
//                      errors,
//                      'gray.700',
//                      false,
//                      false,
//                   )}
//                </GridItem> */}

//                {/* Summary Section */}
//                <Box mt={8} p={4} bg="gray.50" borderRadius="lg">
//                   <Text fontSize="sm" color="gray.600" textAlign="center">
//                      {enabledCount === 0 && 'No fields are currently required'}
//                      {enabledCount === 1 && '1 field is currently required'}
//                      {enabledCount > 1 && `${enabledCount} fields are currently required`}
//                      {enabledCount === totalCount && ' - All fields are enabled'}
//                   </Text>
//                </Box>
//             </CardBody>
//          </Card>
//       </Box>
//    );
// }

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { IoMdArrowRoundBack, IoMdSave, IoMdRefresh, IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { useColorMode } from '@chakra-ui/react';
import { updateUserGlobalSettings, userGlobalSettings } from '../../../../redux/actions/settings';
import { useGlobal } from 'contexts';

// Skeleton Loader Components
const FieldCardSkeleton = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   return (
      <div
         className={`relative p-5 rounded-xl transition-all duration-300 overflow-hidden ${
            isDark ? 'bg-gray-800/60 border-2 border-gray-700/80' : 'bg-white border-2 border-gray-200'
         }`}>
         <div className="relative flex items-center gap-4">
            <div
               className={`flex-shrink-0 w-6 h-6 rounded-lg border-2 ${
                  isDark ? 'border-gray-600 bg-gray-700/50' : 'border-gray-300 bg-gray-50'
               }`}>
               <div className={`w-full h-full rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
            </div>

            <div className="flex-1">
               <div className={`h-5 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} style={{ width: '70%' }} />
            </div>

            <div className={`flex-shrink-0 w-2.5 h-2.5 rounded-full ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
         </div>
      </div>
   );
};

const HeaderSkeleton = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   return (
      <div className="flex items-center gap-4">
         <div
            className={`p-3 rounded-xl ${
               isDark ? 'bg-gray-800 border-2 border-gray-700' : 'bg-white shadow-lg border-2 border-gray-200'
            }`}>
            <div className={`w-5 h-5 ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
         </div>

         <div>
            <div className={`h-8 rounded mb-2 ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} style={{ width: '200px' }} />
            <div className={`h-4 rounded ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`} style={{ width: '300px' }} />
         </div>
      </div>
   );
};

const StatsSkeleton = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   return (
      <div className="flex items-center justify-between">
         <div className="flex items-center gap-3">
            <div
               className={`px-5 py-2.5 rounded-xl ${
                  isDark ? 'bg-gray-700/50 border-2 border-gray-700' : 'bg-gray-100 border-2 border-gray-200'
               }`}>
               <div className="flex items-center gap-1">
                  <div className={`h-6 w-8 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
                  <div className={`h-4 w-2 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
                  <div className={`h-6 w-8 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
                  <div className={`h-3 w-12 rounded ml-2 ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
               </div>
            </div>
         </div>

         <div className="flex items-center gap-3">
            <div
               className={`px-5 py-2.5 rounded-xl ${
                  isDark ? 'bg-gray-700 border-2 border-gray-600' : 'bg-white border-2 border-gray-300'
               }`}>
               <div className={`h-5 w-20 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
            </div>
            <div
               className={`px-6 py-2.5 rounded-xl ${
                  isDark ? 'bg-gray-700 border-2 border-gray-600' : 'bg-white border-2 border-gray-300'
               }`}>
               <div className={`h-5 w-24 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
            </div>
         </div>
      </div>
   );
};

const SectionHeaderSkeleton = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   return (
      <div className="mb-4 pb-3 border-b-2">
         <div className="flex items-center gap-3">
            <div className={`w-1.5 h-8 rounded-full ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
            <div className={`h-6 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} style={{ width: '150px' }} />
            <div
               className={`px-3 py-1 rounded-lg ${
                  isDark ? 'bg-gray-700 border border-gray-600' : 'bg-gray-100 border border-gray-300'
               }`}>
               <div className={`h-4 w-8 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
            </div>
         </div>
      </div>
   );
};

export default function GlobalSetting() {
   const { userGlobalSettingsData } = useGlobal();
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [isUpdating, setIsUpdating] = useState(false);
   const [formData, setFormData] = useState({});
   const [companyWiseWp, setCompanyWiseWp] = useState();
   const [isLoading, setIsLoading] = useState(true);

   const globalSettings = userGlobalSettingsData?.[0];

   useEffect(() => {
      if (globalSettings?.askCompany) {
         setFormData(globalSettings.askCompany);
         setCompanyWiseWp(globalSettings.companyWiseWp);
         setIsLoading(false);
      } else {
         // If no data yet, keep loading
         setIsLoading(true);
      }
   }, [globalSettings]);

   const handleSubmit = async () => {
      setIsUpdating(true);
      try {
         const payload = {
            id: globalSettings.id,
            status: globalSettings.status,
            deviceId: globalSettings.deviceId,
            instanceId: globalSettings.instanceId,
            accessToken: globalSettings.accessToken,
            companyWiseWp: companyWiseWp,
            askCompany: formData,
         };
         await dispatch(updateUserGlobalSettings(payload));
         await dispatch(userGlobalSettings());
      } catch (error) {
         console.error('Error updating settings:', error);
      } finally {
         setIsUpdating(false);
      }
   };

   const handleCheckboxChange = (fieldName, isChecked) => {
      if (fieldName === 'companyWiseWp') {
         setCompanyWiseWp(isChecked);
      } else {
         setFormData((prev) => ({
            ...prev,
            [fieldName]: isChecked,
         }));
      }
   };

   const settingsFields = [
      { key: 'account', label: 'Account', category: 'company' },
      { key: 'bllTerm', label: 'Bill Term', category: 'company' },
      { key: 'daybook', label: 'Daybook', category: 'company' },
      { key: 'bankBranch', label: 'Bank Branch', category: 'company' },
      { key: 'item', label: 'Item', category: 'inventory' },
      { key: 'category', label: 'Category', category: 'inventory' },
      { key: 'itemGroup', label: 'Item Group', category: 'inventory' },
      { key: 'brand', label: 'Brand', category: 'inventory' },
      { key: 'size', label: 'Size', category: 'inventory' },
      { key: 'color', label: 'Color', category: 'inventory' },
      { key: 'style', label: 'Style', category: 'inventory' },
      { key: 'series', label: 'Series', category: 'inventory' },
      { key: 'warehouse', label: 'Warehouse', category: 'logistics' },
      { key: 'transport', label: 'Transport', category: 'logistics' },
      { key: 'driver', label: 'Driver', category: 'logistics' },
      { key: 'vehicle', label: 'Vehicle', category: 'logistics' },
      { key: 'companyWiseWp', label: 'Company Wise Wp', category: 'system' },
   ];

   const hasChanges =
      JSON.stringify(formData) !== JSON.stringify(globalSettings?.askCompany || {}) ||
      companyWiseWp !== globalSettings?.companyWiseWp;

   const enabledCount = settingsFields.filter((field) =>
      field.key === 'companyWiseWp' ? companyWiseWp : formData[field.key],
   ).length;
   const totalCount = settingsFields.length;

   const companyFields = settingsFields.filter((f) => f.category === 'company');
   const inventoryFields = settingsFields.filter((f) => f.category === 'inventory');
   const logisticsFields = settingsFields.filter((f) => f.category === 'logistics');
   const systemFields = settingsFields.filter((f) => f.category === 'system');

   const renderFieldCard = (field) => {
      const isChecked = field.key === 'companyWiseWp' ? companyWiseWp : formData[field.key];

      return (
         <div
            key={field.key}
            onClick={() => !isUpdating && handleCheckboxChange(field.key, !isChecked)}
            className={`relative p-5 rounded-xl transition-all duration-300 cursor-pointer group overflow-hidden ${
               isChecked
                  ? isDark
                     ? 'bg-gradient-to-br from-blue-900/40 to-blue-800/30 border-2 border-blue-500/60 shadow-lg shadow-blue-900/30'
                     : 'bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-400/70 shadow-md shadow-blue-200/50'
                  : isDark
                  ? 'bg-gray-800/60 border-2 border-gray-700/80 hover:border-blue-600/50 hover:bg-gray-800/80'
                  : 'bg-white border-2 border-gray-200 hover:border-blue-300/60 hover:shadow-md'
            } ${!isUpdating && 'hover:scale-[1.02] hover:shadow-xl'}`}>
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
               <div
                  className={`absolute inset-0 ${
                     isDark
                        ? 'bg-gradient-to-r from-transparent via-blue-400/10 to-transparent'
                        : 'bg-gradient-to-r from-transparent via-blue-300/20 to-transparent'
                  } translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000`}
               />
            </div>

            <div className="relative flex items-center gap-4">
               <div
                  className={`flex-shrink-0 w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all duration-300 ${
                     isChecked
                        ? 'bg-gradient-to-br from-blue-500 to-blue-600 border-blue-400 shadow-lg shadow-blue-500/40'
                        : isDark
                        ? 'border-gray-600 bg-gray-700/50'
                        : 'border-gray-300 bg-gray-50'
                  }`}>
                  {isChecked && (
                     <svg
                        className="w-4 h-4 text-white animate-in zoom-in duration-200"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                     </svg>
                  )}
               </div>

               <div className="flex-1">
                  <p
                     className={`font-semibold text-base transition-colors ${
                        isDark
                           ? isChecked
                              ? 'text-blue-100'
                              : 'text-gray-200'
                           : isChecked
                           ? 'text-blue-900'
                           : 'text-gray-800'
                     }`}>
                     {field.label}
                  </p>
               </div>

               <div
                  className={`flex-shrink-0 w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                     isChecked
                        ? 'bg-green-400 shadow-lg shadow-green-400/50 ring-4 ring-green-400/20'
                        : isDark
                        ? 'bg-gray-600'
                        : 'bg-gray-300'
                  }`}
               />
            </div>
         </div>
      );
   };

   return (
      <div
         className={`min-h-screen pb-10 transition-colors duration-300 ${
            isDark
               ? 'bg-gradient-to-br from-gray-900 via-gray-900 to-gray-800'
               : 'bg-gradient-to-br from-gray-50 via-blue-50/30 to-gray-50'
         }`}>
         <div className="pt-8 px-6 pb-6">
            {isLoading ? (
               <HeaderSkeleton />
            ) : (
               <div className="flex items-center gap-4">
                  <Link to="/admin/setting">
                     <button
                        className={`p-3 rounded-xl transition-all duration-300 hover:scale-105 ${
                           isDark
                              ? 'bg-gray-800 hover:bg-gray-700 text-gray-200 border-2 border-gray-700'
                              : 'bg-white hover:bg-gray-50 text-gray-700 shadow-lg border-2 border-gray-200'
                        }`}>
                        <IoMdArrowRoundBack size={20} />
                     </button>
                  </Link>

                  <div>
                     <h1 className={`text-3xl font-bold tracking-tight ${isDark ? 'text-white' : 'text-gray-900'}`}>
                        Master Settings
                     </h1>
                     <p className={`text-sm mt-1 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Configure company-wise master data requirements
                     </p>
                  </div>
               </div>
            )}
         </div>

         <div className="px-6">
            <div
               className={`rounded-2xl shadow-2xl border-2 overflow-hidden transition-all duration-300 ${
                  isDark
                     ? 'bg-gray-800/80 backdrop-blur-xl border-gray-700/50'
                     : 'bg-white/80 backdrop-blur-xl border-gray-200/50'
               }`}>
               <div
                  className={`px-6 py-5 border-b-2 ${
                     isDark ? 'border-gray-700/50 bg-gray-800/50' : 'border-gray-200/50 bg-gray-50/50'
                  }`}>
                  {isLoading ? (
                     <StatsSkeleton />
                  ) : (
                     <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                           <div
                              className={`px-5 py-2.5 rounded-xl font-bold text-sm transition-all duration-300 ${
                                 enabledCount === totalCount
                                    ? isDark
                                       ? 'bg-gradient-to-r from-green-900/40 to-emerald-900/40 text-green-300 border-2 border-green-700/50 shadow-lg shadow-green-900/20'
                                       : 'bg-gradient-to-r from-green-50 to-emerald-50 text-green-700 border-2 border-green-300/50 shadow-md shadow-green-200/50'
                                    : isDark
                                    ? 'bg-gradient-to-r from-blue-900/40 to-indigo-900/40 text-blue-300 border-2 border-blue-700/50 shadow-lg shadow-blue-900/20'
                                    : 'bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 border-2 border-blue-300/50 shadow-md shadow-blue-200/50'
                              }`}>
                              <span className="text-2xl font-bold">{enabledCount}</span>
                              <span className="mx-1">/</span>
                              <span className="text-lg">{totalCount}</span>
                              <span className="ml-2 text-xs opacity-80">ENABLED</span>
                           </div>
                        </div>

                        <div className="flex items-center gap-3">
                           <button
                              onClick={() => {
                                 setFormData(globalSettings?.askCompany || {});
                                 setCompanyWiseWp(globalSettings?.companyWiseWp);
                              }}
                              disabled={!hasChanges || isUpdating}
                              className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300 ${
                                 !hasChanges || isUpdating
                                    ? isDark
                                       ? 'bg-gray-700/50 text-gray-500 cursor-not-allowed border-2 border-gray-700'
                                       : 'bg-gray-100 text-gray-400 cursor-not-allowed border-2 border-gray-200'
                                    : isDark
                                    ? 'bg-gray-700 text-gray-200 hover:bg-gray-600 border-2 border-gray-600 hover:scale-105 shadow-lg'
                                    : 'bg-white text-gray-700 hover:bg-gray-50 border-2 border-gray-300 hover:scale-105 shadow-md hover:shadow-lg'
                              }`}>
                              <IoMdRefresh size={18} />
                              Reset
                           </button>

                           <button
                              onClick={handleSubmit}
                              disabled={!hasChanges || isUpdating}
                              className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300 ${
                                 !hasChanges
                                    ? isDark
                                       ? 'bg-gray-700/50 text-gray-500 cursor-not-allowed border-2 border-gray-700'
                                       : 'bg-gray-200 text-gray-400 cursor-not-allowed border-2 border-gray-300'
                                    : 'bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 shadow-xl shadow-blue-500/50 hover:shadow-2xl hover:scale-105 border-2 border-blue-500'
                              }`}>
                              {isUpdating ? (
                                 <>
                                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                       <circle
                                          className="opacity-25"
                                          cx="12"
                                          cy="12"
                                          r="10"
                                          stroke="currentColor"
                                          strokeWidth="4"
                                          fill="none"
                                       />
                                       <path
                                          className="opacity-75"
                                          fill="currentColor"
                                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                       />
                                    </svg>
                                    Saving...
                                 </>
                              ) : (
                                 <>
                                    <IoMdSave size={18} />
                                    Save Settings
                                 </>
                              )}
                           </button>
                        </div>
                     </div>
                  )}
               </div>

               <div className="p-6">
                  {isLoading ? (
                     // Loading state for all sections
                     <>
                        {/* Changes Notification Skeleton */}
                        <div
                           className={`mb-6 p-4 rounded-xl border-l-4 ${
                              isDark
                                 ? 'bg-gray-800/30 border-2 border-gray-700'
                                 : 'bg-gray-100 border-2 border-gray-200'
                           }`}>
                           <div className="flex items-center gap-3">
                              <div className={`w-6 h-6 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`} />
                              <div
                                 className={`h-4 rounded ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`}
                                 style={{ width: '250px' }}
                              />
                           </div>
                        </div>

                        {/* Company Settings Section Skeleton */}
                        <div className="mb-8">
                           <SectionHeaderSkeleton />
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              {Array.from({ length: 4 }).map((_, index) => (
                                 <FieldCardSkeleton key={index} />
                              ))}
                           </div>
                        </div>

                        {/* Inventory Settings Section Skeleton */}
                        <div className="mb-8">
                           <SectionHeaderSkeleton />
                           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                              {Array.from({ length: 9 }).map((_, index) => (
                                 <FieldCardSkeleton key={index} />
                              ))}
                           </div>
                        </div>

                        {/* Logistics Settings Section Skeleton */}
                        <div className="mb-8">
                           <SectionHeaderSkeleton />
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              {Array.from({ length: 4 }).map((_, index) => (
                                 <FieldCardSkeleton key={index} />
                              ))}
                           </div>
                        </div>

                        {/* System Settings Section Skeleton */}
                        <div>
                           <SectionHeaderSkeleton />
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              {Array.from({ length: 1 }).map((_, index) => (
                                 <FieldCardSkeleton key={index} />
                              ))}
                           </div>
                        </div>

                        {/* Summary Skeleton */}
                        <div
                           className={`mt-8 p-6 rounded-xl border-2 ${
                              isDark ? 'bg-gray-800/60 border-gray-700/50' : 'bg-gray-50 border-gray-200/50'
                           }`}>
                           <div
                              className={`h-5 rounded mx-auto ${isDark ? 'bg-gray-600' : 'bg-gray-300'}`}
                              style={{ width: '200px' }}
                           />
                        </div>
                     </>
                  ) : (
                     // Actual content when not loading
                     <>
                        {hasChanges && (
                           <div
                              className={`mb-6 p-4 rounded-xl border-l-4 transition-all duration-300 ${
                                 isDark
                                    ? 'bg-gradient-to-r from-blue-900/30 to-blue-800/20 border-blue-500 border-2 border-l-4'
                                    : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-400 border-2 border-l-4 shadow-md shadow-blue-200/50'
                              }`}>
                              <div className="flex items-center gap-3">
                                 <IoMdCheckmarkCircleOutline
                                    className={`${isDark ? 'text-blue-400' : 'text-blue-600'} flex-shrink-0`}
                                    size={22}
                                 />
                                 <p className={`text-sm font-medium ${isDark ? 'text-blue-200' : 'text-blue-800'}`}>
                                    You have unsaved changes. Click "Save Settings" to apply them.
                                 </p>
                              </div>
                           </div>
                        )}

                        <div className="mb-8">
                           <div
                              className={`mb-4 pb-3 border-b-2 ${
                                 isDark ? 'border-purple-800/40' : 'border-purple-200/60'
                              }`}>
                              <div className="flex items-center gap-3">
                                 <div
                                    className={`w-1.5 h-8 rounded-full ${
                                       isDark
                                          ? 'bg-gradient-to-b from-purple-500 to-purple-700'
                                          : 'bg-gradient-to-b from-purple-400 to-purple-600'
                                    }`}
                                 />
                                 <h2 className={`text-xl font-bold ${isDark ? 'text-purple-300' : 'text-purple-800'}`}>
                                    Company Settings
                                 </h2>
                                 <div
                                    className={`px-3 py-1 rounded-lg text-xs font-bold ${
                                       isDark
                                          ? 'bg-purple-900/40 text-purple-300 border border-purple-700/50'
                                          : 'bg-purple-100 text-purple-700 border border-purple-300/50'
                                    }`}>
                                    {companyFields.filter((f) => formData[f.key]).length}/{companyFields.length}
                                 </div>
                              </div>
                           </div>
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              {companyFields.map(renderFieldCard)}
                           </div>
                        </div>

                        <div className="mb-8">
                           <div
                              className={`mb-4 pb-3 border-b-2 ${
                                 isDark ? 'border-emerald-800/40' : 'border-emerald-200/60'
                              }`}>
                              <div className="flex items-center gap-3">
                                 <div
                                    className={`w-1.5 h-8 rounded-full ${
                                       isDark
                                          ? 'bg-gradient-to-b from-emerald-500 to-emerald-700'
                                          : 'bg-gradient-to-b from-emerald-400 to-emerald-600'
                                    }`}
                                 />
                                 <h2
                                    className={`text-xl font-bold ${isDark ? 'text-emerald-300' : 'text-emerald-800'}`}>
                                    Inventory Settings
                                 </h2>
                                 <div
                                    className={`px-3 py-1 rounded-lg text-xs font-bold ${
                                       isDark
                                          ? 'bg-emerald-900/40 text-emerald-300 border border-emerald-700/50'
                                          : 'bg-emerald-100 text-emerald-700 border border-emerald-300/50'
                                    }`}>
                                    {inventoryFields.filter((f) => formData[f.key]).length}/{inventoryFields.length}
                                 </div>
                              </div>
                           </div>
                           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                              {inventoryFields.map(renderFieldCard)}
                           </div>
                        </div>

                        <div className="mb-8">
                           <div
                              className={`mb-4 pb-3 border-b-2 ${
                                 isDark ? 'border-amber-800/40' : 'border-amber-200/60'
                              }`}>
                              <div className="flex items-center gap-3">
                                 <div
                                    className={`w-1.5 h-8 rounded-full ${
                                       isDark
                                          ? 'bg-gradient-to-b from-amber-500 to-amber-700'
                                          : 'bg-gradient-to-b from-amber-400 to-amber-600'
                                    }`}
                                 />
                                 <h2 className={`text-xl font-bold ${isDark ? 'text-amber-300' : 'text-amber-800'}`}>
                                    Logistics Settings
                                 </h2>
                                 <div
                                    className={`px-3 py-1 rounded-lg text-xs font-bold ${
                                       isDark
                                          ? 'bg-amber-900/40 text-amber-300 border border-amber-700/50'
                                          : 'bg-amber-100 text-amber-700 border border-amber-300/50'
                                    }`}>
                                    {logisticsFields.filter((f) => formData[f.key]).length}/{logisticsFields.length}
                                 </div>
                              </div>
                           </div>
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              {logisticsFields.map(renderFieldCard)}
                           </div>
                        </div>

                        <div>
                           <div
                              className={`mb-4 pb-3 border-b-2 ${
                                 isDark ? 'border-cyan-800/40' : 'border-cyan-200/60'
                              }`}>
                              <div className="flex items-center gap-3">
                                 <div
                                    className={`w-1.5 h-8 rounded-full ${
                                       isDark
                                          ? 'bg-gradient-to-b from-cyan-500 to-cyan-700'
                                          : 'bg-gradient-to-b from-cyan-400 to-cyan-600'
                                    }`}
                                 />
                                 <h2 className={`text-xl font-bold ${isDark ? 'text-cyan-300' : 'text-cyan-800'}`}>
                                    System Settings
                                 </h2>
                                 <div
                                    className={`px-3 py-1 rounded-lg text-xs font-bold ${
                                       isDark
                                          ? 'bg-cyan-900/40 text-cyan-300 border border-cyan-700/50'
                                          : 'bg-cyan-100 text-cyan-700 border border-cyan-300/50'
                                    }`}>
                                    {
                                       systemFields.filter((f) =>
                                          f.key === 'companyWiseWp' ? companyWiseWp : formData[f.key],
                                       ).length
                                    }
                                    /{systemFields.length}
                                 </div>
                              </div>
                           </div>
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              {systemFields.map(renderFieldCard)}
                           </div>
                        </div>

                        <div
                           className={`mt-8 p-6 rounded-xl border-2 text-center transition-all duration-300 ${
                              isDark
                                 ? 'bg-gradient-to-br from-gray-800/60 to-gray-700/40 border-gray-700/50'
                                 : 'bg-gradient-to-br from-gray-50 to-blue-50/30 border-gray-200/50'
                           }`}>
                           <p className={`text-base font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                              {enabledCount === 0 && '🔒 No fields are currently required'}
                              {enabledCount === 1 && '✨ 1 field is currently required'}
                              {enabledCount > 1 &&
                                 enabledCount < totalCount &&
                                 `⚙️ ${enabledCount} fields are currently required`}
                              {enabledCount === totalCount && '🎉 All fields are enabled - Maximum security!'}
                           </p>
                        </div>
                     </>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
}
